import { render, staticRenderFns } from "./payment-method.vue?vue&type=template&id=39f91474&"
import script from "./payment-method.vue?vue&type=script&lang=js&"
export * from "./payment-method.vue?vue&type=script&lang=js&"
import style0 from "./payment-method.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f91474')) {
      api.createRecord('39f91474', component.options)
    } else {
      api.reload('39f91474', component.options)
    }
    module.hot.accept("./payment-method.vue?vue&type=template&id=39f91474&", function () {
      api.rerender('39f91474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/payment/payment-methods-modal/payment-method.vue"
export default component.exports